import { cn } from '../../lib/format.js';

/**
 * The masthead: the house logo laid out in a line — the crowned monogram, then
 * the name — cut from the Golden Era logo with a transparent ground, so it sits
 * on any surface. The monogram is always the house gold. `tone` only decides
 * the lettering: ink on the light pages (checkout, maintenance, the error
 * screen), gold on the black header.
 *
 * Height comes from `className`; the width follows the artwork's proportions.
 * The file is drawn at twice the largest height it is shown at.
 */
export const Wordmark = ({ className, tone = 'dark' }) => (
  <img
    src={tone === 'light' ? '/brand/golden-era-lockup-light.png' : '/brand/golden-era-lockup-dark.png'}
    alt="Golden Era"
    width="472"
    height="112"
    decoding="async"
    className={cn('block w-auto max-w-none select-none', className)}
  />
);

/**
 * The full logo — crown, monogram, name, and "Attar and perfume" — stacked as
 * the house sets it. Gold on a transparent ground, for black surfaces.
 */
export const StackedLogo = ({ className }) => (
  <img
    src="/brand/golden-era-logo.png"
    alt="Golden Era, attar and perfume"
    width="452"
    height="240"
    loading="lazy"
    decoding="async"
    className={cn('block w-auto max-w-none select-none', className)}
  />
);

export default Wordmark;
